import Button from '@/components/Button';
import PageHeader from '@/components/PageHeader';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import UserTable from '@/modules/admin/components/UserTable';
import { UserAddPath } from '@/modules/admin/paths';
import { PlusIcon } from '@heroicons/react/24/solid';

const UserList = () => {
  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  return (
    <div>
      <Breadcrumbs />

      <PageHeader title="Users">
        <Button to={UserAddPath} icon={<PlusIcon className="h-5 w-5 mr-1" />} variant="secondary">
          Add User
        </Button>
      </PageHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <UserTable searchQuery={searchQuery} page={page} onChangePage={handlePageChange} />
    </div>
  );
};

export default UserList;
